import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button, Spinner } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import Selector from 'modules/core/components/Selector'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import useAddCompetenciesToRole from 'modules/job_catalog/hooks/useAddCompetenciesToRole'
import { useCompetencies } from 'modules/job_catalog/hooks/useCompetencies'
import { useRoleCompetencies } from 'modules/job_catalog/hooks/useRoleCompetencies'

const Component = () => {
  const { id } = useParams<{ id: string }>()
  const roleId = parseInt(id as string)
  const navigate = useNavigate()
  const [competencies, fetchingCompetencies] = useCompetencies()
  const [roleCompetencies, fetchingRoleCompetencies] = useRoleCompetencies(roleId)
  const { addCompetenciesToRole, isLoading: isAddingCompetenciesToRole } =
    useAddCompetenciesToRole()
  const [selected, setSelected] = React.useState<number[]>([])

  const options = competencies
    ?.filter((x) => !roleCompetencies?.find((y) => y.id === x.id))
    ?.map((x) => (
      <Selector.Option key={x.id} value={x.id} searchValue={x.name} label={x.name}>
        {x.name}
      </Selector.Option>
    ))

  const handleClose = () => {
    track(trackingEvents.jobCatalog.jobRoleAssignCompetencyCancel)
    navigate(-1)
  }

  const handleSubmit = async () => {
    track(trackingEvents.jobCatalog.jobRoleAssignCompetencySubmit)
    await addCompetenciesToRole(roleId, selected)
    handleClose()
  }

  return (
    <Modal
      illustration="document-folder-board-edit"
      title={i18n.t('job_catalog.competencies.title')}
      description={i18n.t('job_catalog.competencies.assign_competencies_description')}
      onClose={handleClose}
      onSubmit={handleSubmit}
      footer={
        <Box flexDirection="row" gap="s8">
          <Button type="secondary" onClick={handleClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={!selected.length} submit>
            {i18n.t('common.submit')}
          </Button>
        </Box>
      }
    >
      {fetchingCompetencies || fetchingRoleCompetencies || isAddingCompetenciesToRole ? (
        <Box alignItems="center">
          <Spinner />
        </Box>
      ) : (
        <Selector.Container
          value={selected}
          searchPlaceholder={i18n.t('common.search')}
          blankLabel={i18n.t('job_catalog.competencies.no_competencies_found')}
          // eslint-disable-next-line no-type-assertion/no-type-assertion -- Selector component has no generics
          onChange={(x) => setSelected(x as number[])}
          isMultiSelect
        >
          {options || []}
        </Selector.Container>
      )}
    </Modal>
  )
}

export default Component
